import React from "react";

type EyebrowProps = {
  variant?: "pill" | "plain";
  withDot?: boolean;
  className?: string;
  children: React.ReactNode;
};

/**
 * Eyebrow text — small, uppercase, used to label sections or hero callouts.
 *
 * - `variant="pill"` (default for hero) renders as a small purple pill, optionally with a pink dot.
 * - `variant="plain"` (default for sections) renders as flat text, e.g. "— 01 / Get running".
 */
export function Eyebrow({
  variant = "plain",
  withDot,
  className,
  children,
}: EyebrowProps) {
  const baseClass = variant === "pill" ? "tb-eyebrow" : "tb-section-eyebrow";
  const cls = [baseClass, className].filter(Boolean).join(" ");
  return (
    <span className={cls}>
      {variant === "pill" && withDot ? (
        <span className="tb-eyebrow-dot" />
      ) : null}
      {children}
    </span>
  );
}
